module.exports = __webpack_public_path__ + "img/mft-logo.f1593ce1.png";